import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class CustomContentRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async getCustomContent(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/lp-events/active-by-url`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getEventsToRedirect(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/lp-events/all-active-events-redirect`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getWifiPageDetails(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/special-benefits/by-identifier?identifier=wifi`,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
